import{css as o}from"styled-components";var e=o(["-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"]);export{e as hideScrollbar};
